<tec-modal
    [isVisible]="true"
    [title]="'OPERATIONS.DATA_COMPARISON_MODAL.TITLE' | translate"
    type="scrollable"
    (closeEvent)="closeEvent.emit()"
>
    <ng-container body>
        <tec-tile
            [title]="'OPERATIONS.DATA_COMPARISON_MODAL.FACE_TITLE' | translate"
            [subtitle]="
                'OPERATIONS.DATA_COMPARISON_MODAL.FACE_SUBTITLE' | translate
            "
        >
            @if (showFaceAlert) {
                <tec-alert
                    [msg]="'OPERATIONS.DATA_COMPARISON_MODAL.FACE_ALERT' | translate"
                    [hiddenCloseButton]="true"
                />
            }

            <div class="grid grid-i2">
                @if (polImages?.selfie?.[0]) {
                    <tec-file-preview [fileUrl]="polImages?.selfie?.[0]" [sizeSm]="true" />
                } @if (ocrFrontPreviewUrl) {
                    <tec-file-preview [fileUrl]="ocrFrontPreviewUrl" [sizeSm]="true" />
                }
            </div>
        </tec-tile>

        <tec-tile
            [title]="'OPERATIONS.DATA_COMPARISON_MODAL.AGE_TITLE' | translate"
            [subtitle]="
                'OPERATIONS.DATA_COMPARISON_MODAL.AGE_SUBTITLE' | translate
            "
        >
            @if (showAgeAlert) {
                <tec-alert
                    [msg]="'OPERATIONS.DATA_COMPARISON_MODAL.AGE_ALERT' | translate"
                    [hiddenCloseButton]="true"
                />
            }

            <div class="grid grid-i2">
                <tec-info-group [label]="'OPERATIONS.DATA_COMPARISON_MODAL.ESTIMATED_AGE_LABEL' | translate">
                    <span>{{ 'OPERATIONS.DATA_COMPARISON_MODAL.AGE_RANGE' | translate : { low_age: ages?.low_age, high_age: ages?.high_age } }}</span>
                </tec-info-group>
                <tec-info-group [label]="'OPERATIONS.DATA_COMPARISON_MODAL.DOCUMENT_LABEL' | translate">
                    <span>
                        {{ (birthdate | date : 'dd/MM/yyyy') || ('GENERAL.NOT_AVAILABLE' | translate) }}
                    </span>
                    @if (yearsOld) {
                    <tec-tag status="success">
                        {{ 'PROCESSES.DETAIL.YEARS' | translate : { years_old: yearsOld } }}
                    </tec-tag>
                    }
                </tec-info-group>
            </div>
        </tec-tile>
    </ng-container>
</tec-modal>
